/*@ngInject*/
const FormTemplateErrorModalController = function ($rootScope, $scope, coreConstant, options) {

    $scope.title = options.title;
    $scope.okButton = options.confirmActionButtonLabel;

    $scope.viewModel = {
        summary: options.summary,
        errors: options.errors
    };

    $scope.onConfirm = function () {
        $scope.$close();
    };

    $scope.onCancel = function () {
        $scope.$dismiss();
    };

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('umCore')
    .controller('formTemplateErrorModalController', FormTemplateErrorModalController);
